import Name from './Name';
import withHandlers from 'recompose/withHandlers';
import { getCountryFromPath } from 'src/common/l10n/country';

import formatAdventurerName from 'src/common/utils/format-adventurer-name';

const enhance = withHandlers({
  onHandleChange: props => event => {

    let formattedName = event.target.value;

    if (event.target.name === 'name' || event.target.name === 'surname') {
      const country = getCountryFromPath(window.location.pathname);
      // Japanese character sets often convert two consecutive letters to a single symbol.
      // As soon as one character is entered we format it, uppercase it and set it as the field value.
      // This results means that the user sees one capital latin character and a second incorrect character.
      // For japan we don't format the name so that we get the correct letters input. We may need to decided to
      // do something different for different books in the future for japan - maybe detect correct character set.
      // This should be part of the muse validation work.
      if (country && country.locale !== 'ja') {
        formattedName = formatAdventurerName(formattedName);
      }
    }

    if (props.trackNameChange) {
      props.trackNameChange(formattedName);
    }

    event.target.value = formattedName;
    props.onHandleChange(event);
  }
});

export default enhance(Name);
